import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics, type Analytics, isSupported } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyBehlZSxbNPRLxAMWnT2gz8CQDdhwuZs8U",
  authDomain: "eczaneanaliz-571d1.firebaseapp.com",
  projectId: "eczaneanaliz-571d1",
  storageBucket: "eczaneanaliz-571d1.firebasestorage.app",
  messagingSenderId: "642307859819",
  appId: "1:642307859819:web:f6ad359efafc5ff75c182e",
  measurementId: "G-2FMZK0VLSZ"
};

// Debug logs only in development
if (process.env.NODE_ENV === 'development') {
  console.log('🔥 Firebase Config Yükleniyor:', {
    projectId: firebaseConfig.projectId,
    authDomain: firebaseConfig.authDomain,
    apiKey: firebaseConfig.apiKey.substring(0, 20) + '...'
  });
}

const app = initializeApp(firebaseConfig);

// Debug logs only in development
if (process.env.NODE_ENV === 'development') {
  console.log('✅ Firebase App Initialized:', {
    name: app.name,
    options: {
      projectId: app.options.projectId,
      authDomain: app.options.authDomain
    }
  });
  console.log('✅ Firebase Project ID:', firebaseConfig.projectId);
}

// Auth'u başlat
export const auth = getAuth(app);

// Firestore'u başlat
export const db = getFirestore(app);

// Analytics'i yalnızca browser ortamında başlat
let analyticsInstance: Analytics | null = null;
if (typeof window !== 'undefined') {
  isSupported()
    .then((supported) => {
      if (supported) {
        analyticsInstance = getAnalytics(app);
        if (process.env.NODE_ENV === 'development') {
          console.log('✅ Firebase Analytics initialized');
        }
      } else if (process.env.NODE_ENV === 'development') {
        console.log('ℹ️ Firebase Analytics this environment does not support analytics');
      }
    })
    .catch((err) => {
      console.warn('⚠️ Firebase Analytics init error:', err);
    });
}

export const analytics = analyticsInstance;
